import { useTranslation } from "react-i18next";
import useCrudFilters from "../../../../hooks/useCrudFilters";
import useCrudTable from "../../../../hooks/useCrudTable";
import { LogTableColumns } from "../../domain/columns/logTableColumns";
import { logSchema } from "../../domain/schemas/logSchema";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import { LogTableFilters } from "../features/LogTableFilters";

export const LogsPage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.auth.user);

  if (
    !currentUser ||
    (currentUser.role !== "super-admin" && currentUser.role !== "dbh-manager")
  ) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  const title = t("Logs");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootActivityInput",
      fields: {},
    },
    "logsFilter",
  );

  const crud = useCrudTable({
    prefix: "logs",
    entity: "ActivityInput",
    columns: LogTableColumns,
    schema: logSchema,
    filters: crudFilters.filters,
    defaultSorting: [
      {
        id: "created_at",
        desc: true,
      },
    ],
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <LogTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
